module.exports = __webpack_public_path__ + "img/wp.50b1c66d.svg";